if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: false,
			numberFilterTree: 2,
			selectOptionContainer: '.grid__item .card-wrapper',
			stickyFixTopPos: true
		},
		selector: {
			otpTopCartCount: '.cart-count-bubble'
		}
	};
  //console.log('boostPFSFilterConfig', boostPFSFilterConfig)
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function() {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var cardHeader = data.collections[0].title === "FREEBIRD STORES - MY FIRST FREEBIRD" ?
      `<span class="baby-card-header">
            <div class="mt2">{{itemTitle}}</div>
            <div class="baby-card-subheader">{{itemColor}}</div>
          </span>` : `<span class="card-information__text h5">{{itemTitle}}
            <div class="color-name">{{itemColor}}</div>
          </span>`;


    itemHtml = itemHtml.replace(/{{cardHeader}}/g, cardHeader);
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    //split up title
    const titleArray = data.title.split(" - ");
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, titleArray[0]);
    //itemHtml = itemHtml.replace(/{{itemColor}}/g, titleArray[1]);
    itemHtml = itemHtml.replace(/{{itemColor}}/g, titleArray[1] ? titleArray[1] : ' ');

    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '',
      aspectRatio = '',
      rangeWidths = boostPFSRangeWidths,
      paddingBottom = 100;

    var dataSrcSet = '',
      imgAlt = data.title,
      flipImageSrcSet = '';

    var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
      boostPFSThemeConfig.custom.show_secondary_image == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

      if (activeSwapImage) {
        flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ', ';

        if (activeSwapImage) {
          flipImageSrcSet += ', ';
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]['width'] / images[0]['height'];
      paddingBottom = 1 / aspectRatio * 100;
      boxWidth = $('img.motion-reduce').width();
      fallbackBoxWidth = $(window).width();
      fallbackBoxWidth = fallbackBoxWidth / 5;

      if ( boxWidth == null){
        boxWidth = fallbackBoxWidth;
      } else {
        boxWidth = $('img.motion-reduce').width();
      }
      displaySize = Math.round(boxWidth)


      html += '<div';
      if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
        boostPFSThemeConfig.custom.add_image_padding === true) {
        html += ' class="card__media-full-spacer"';
      }
      html += '>';
      html += '<div class="media media--transparent media--';
      if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
        html += boostPFSThemeConfig.custom.media_size;
      }
      html += ' media--hover-effect"';
      if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
        boostPFSThemeConfig.custom.media_size == 'adapt' &&
        images.length > 0) {
        html += ' style="padding-bottom: ' + paddingBottom + '%"';
      }
      html += '>'
      html += '<img class="motion-reduce"' +
        'loading="lazy"' +
        // 'srcset="' + dataSrcSet + '" ' +
        // 'height="' + images[0].height + '" ' +
        // 'width="' + images[0].width + '" ' +
        //'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
        'src="' + images[0].src + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
          'loading="lazy"' +
          // 'srcset="' + flipImageSrcSet + '" ' +
          // 'height="' + images[1].height + '" ' +
          // 'width="' + images[1].width + '" ' +
          //'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
          'src="' + images[1].src + '" ' +
          'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += '<div class="card__content"><h2 class="card__text h2">' + data.title + '</h2></div>'
    }
    return html;
  }

  function buildCardProductClass() {
    var html = '';
    if (!images || (images && images.length === 0)) {
      html = 'card--text-only card--soft';
    } else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
        var saleTag = data.tags.includes("sandal") ? "EXTRA" : "NOW"
        var textAlign = data.collections[0].title === "My First Freebird" ? "text-align: center;" : ""
        var New_price = moneyPrice.split('.')
        var New_price_compare = Utils.formatMoney(data.compare_at_price_min).split('.')
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl style="margin-top: 12px !important; ${textAlign}">
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular np">
        ${New_price[0]}
				  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular ncp">
        ${New_price_compare[0]}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last test">
								<span class="price-item price-item--sale">
                                    ${saleTag} ${Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min)}% OFF
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}
  
	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if (paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function() {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ('.collection-filters__sort').change(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  FilterOptionItemList.prototype.getTemplate = function() {
    // Filter by collection uses <a> tag
    if (this.parent.filterType == FilterOptionEnum.FilterType.COLLECTION) {
      return `
				<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
					<a class="{{class.button}}" href="{{href}}">
            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{labelledbyvalue}}"></span>
						<span class="boost-pfs-filter-option-value" id="{{labelledbyvalue}}">{{label}}</span>
						<span class="boost-pfs-filter-option-amount" id="{{labelledbycount}}">{{countLabel}}</span>
					</a>
				</li>
			`.trim();
      // Else uses <button>
    } else {
      return `
				<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
					<button role="checkbox" class="{{class.button}}">
            <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{labelledbyvalue}}"></span>
						<span role="input" tabindex class="boost-pfs-filter-option-value" id="{{labelledbyvalue}}">{{label}}</span>
						<span class="boost-pfs-filter-option-amount" id="{{labelledbycount}}">{{countLabel}}</span>
					</button>
				</li>
			`.trim();
    }
  };


  FilterOptionItemList.prototype.compileTemplate = function() {
    return this.getTemplate()
      .replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
      .replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
      .replace(/{{class.button}}/g, Class.button)
      .replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
      .replace(/{{label}}/g, Utils.stripHtml(this.label))
      .replace(/{{labelledbyvalue}}/g, Utils.slugify(Utils.stripHtml(this.parent.filterOptionId + '-value-' + this.label.toLowerCase())))
      .replace(/{{labelledbycount}}/g, Utils.slugify(Utils.stripHtml(this.parent.filterOptionId + '-count-' + this.label.toLowerCase())))
      .replace(/{{href}}/g, this.href)
      .replace(/{{countLabel}}/g, Utils.stripHtml(this.countLabel));
  };

  FilterOptionItemBox.prototype.getTemplate = function() {
    return `
			<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">
				<button role="checkbox" class="{{class.button}}">
        <span class="boost-pfs-check-box" role="checkbox" aria-checked="false" tabindex="0" aria-labelledby="{{labelledbyvalue}}"></span>
					<span class="boost-pfs-filter-option-value" id="{{labelledbyvalue}}">{{label}}</span>
					<span class="boost-pfs-filter-option-amount" id="{{labelledbycount}}">{{countLabel}}</span>
				</button>
			</li>
		`.trim();
  };

  FilterOptionItemBox.prototype.compileTemplate = function() {
    return this.getTemplate()
      .replace(/{{class.filterOptionItem}}/g, Class.filterOptionItem)
      .replace(/{{class.filterOptionLabel}}/g, Class.filterOptionLabel)
      .replace(/{{disabled}}/g, this.isDisabled() ? 'disabled' : '')
      .replace(/{{class.button}}/g, Class.button)
      .replace(/{{label}}/g, Utils.stripHtml(this.label))
      .replace(/{{labelledbyvalue}}/g, Utils.slugify(Utils.stripHtml(this.parent.filterOptionId + '-value-' + this.label.toLowerCase())))
      .replace(/{{labelledbycount}}/g, Utils.slugify(Utils.stripHtml(this.parent.filterOptionId + '-count-' + this.label.toLowerCase())))
      .replace(/{{countLabel}}/g, Utils.stripHtml(this.countLabel));
  };

  /************************** END BUILD TOOLBAR **************************/




  /**************** End of function() ****************/
})();


if (screen.width > 767 ) {

  function filterURLChange() {
    let queryString = window.location.search;
    let url = window.location.href;
    let georgiaLocation = '?pf_vl_locations=Georgia+Warehouse';

    if (((url.includes('collections') || url.includes('search')) && (url.includes('?') == false) && url.includes('staging') == false && url.includes('127.0.0.1') == false )) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + georgiaLocation;
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    } else if (((url.includes('collections') || url.includes('search')) && (url.includes('?')) && url.includes('staging') == false && url.includes('127.0.0.1') == false ) ) {
      georgiaLocation = '&pf_vl_locations=Georgia+Warehouse';
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString + georgiaLocation;
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    }
  };

  function moveProductsTxt() {
    var moveTxtOnce = $('.filters-toolbar__item-child button').length;
    if (moveTxtOnce < 1) {
      $('ul.boost-pfs-search-result-panel-controls.boost-pfs-search-panel-items-1 li.boost-pfs-search-result-panel-item.boost-active button').insertAfter('label.collection-filters__label')
    }
  }

  function displayLoader() {
    $('div#loading-wrapper').css({
      display: '',
      top: window.pageYOffset - 37,
      backgroundColor: '#eeeeeeee'
    })
  }

  function hideLoader() {
    $('div#loading-wrapper').hide();
  }

  function locationTxtCleanUp() {
    $('span.refine-by-option:contains(Locations:)').closest('.refine-by-item.boost-pfs-filter-option-label').css('display', 'none');
    $('.boost-pfs-filter-option-locations').css('display', 'none');
  }

  function filterWait() {
    $('.boost-pfs-filter-left-col').on('load', function() {
      $('.boost-pfs-filter-tree-desktop-button>button').click();
    })
  }

  function textChanges() {
    var showResultsText = $('button.boost-pfs-filter-show-result').text();
    showResultsText.replace('Show result', 'Apply Filter');
    var applyFilterText = showResultsText.replace('Show result', 'Apply Filter');
    $('button.boost-pfs-filter-show-result').text(applyFilterText);
    $('span.boost-pfs-filter-tree-mobile-button-label, .boost-pfs-filter-mobile-toolbar-middle').text('Filter By')
  }

  function filterMemory() {
    setTimeout(() => {
      hideLoader();
    }, 100)
    var readValue = sessionStorage.getItem('openFilter');
    if (readValue == undefined || readValue == null || readValue == 'open') {
      sessionStorage.setItem('openFilter', 'open');
      $('.boost-pfs-filter-tree-desktop-button > button').click();
    }
    $('.boost-pfs-filter-tree-desktop-button > button').on('click', function() {
      var isItOpen = sessionStorage.getItem('openFilter');
      if (isItOpen == 'closed' || isItOpen == undefined || readValue == null) {
        sessionStorage.setItem('openFilter', 'open');
      } else if (isItOpen == 'open') {
        sessionStorage.setItem('openFilter', 'closed');
      }
    })
  }

  function removeWarehouseFromURL() {
    var normalURL = window.location.href
    if (normalURL.includes('?pf_vl_locations')) {
      var locString = "?pf_vl_locations=Georgia+Warehouse"
    } else if (normalURL.includes('&pf_vl_locations')) {
      var locString = "&pf_vl_locations=Georgia+Warehouse"
    }
    var newString = normalURL.replace(locString, '')

    history.pushState(window.location.href, '', newString)
  }

  function removeExtra() {
    var baseURL = window.location.href;
    var urlCount = baseURL.split('&pf_vl_locations=Georgia+Warehouse');
    //var count = urlCount.length - 1
    history.pushState(window.location.href, '', urlCount[0])
  }

  function filterObserver() {
    let prodFilter_Interval = setInterval(() => {
      let prodFilter_Target = $('#boost-pfs-filter-tree')[0];
      let prodFilter_Observer = new MutationObserver(() => {
        var windowLocation = window.location.href
        if (windowLocation.includes('pf_vl_locations') == false && windowLocation.includes('staging') == false && windowLocation.includes('127.0.0.1') == false ) {
          filterURLChange()
          moveProductsTxt()
        }

      })
      prodFilter_Observer.observe(prodFilter_Target, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: true,
      });
      clearInterval(prodFilter_Interval);
    }, 50);
  }



  function aria_SetID() {
    var labelledBy = []
    $('span.boost-pfs-check-box').each(function() {
      var offender = $(this).attr("aria-labelledby");
      labelledBy.push(offender)
    })

    for (let i = 0; i < labelledBy.length; i++) {
      var aria = labelledBy[i]
      var fix = $('li.boost-pfs-filter-option-item.boost-pfs-filter-option-label span.boost-pfs-filter-option-amount')[i]
      fix.setAttribute('id', labelledBy[i])
      fix.setAttribute('role', 'input')
      fix.setAttribute('aria-label', labelledBy[i])
    }
  }


  window.addEventListener('DOMContentLoaded', () => {
    var windowLocation = window.location.href
    displayLoader()
    filterURLChange()
    //filterObserver()
    filterWait()
    locationTxtCleanUp()
    //aria_SetID()
    if (windowLocation.includes('pf_vl_locations') == false && windowLocation.includes('staging') == false && windowLocation.includes('127.0.0.1') == false) {
      filterURLChange()
    }

    setTimeout(() => {
      locationTxtCleanUp()
      filterMemory()
    }, 650)

    // setTimeout(() => {
    // 	removeWarehouseFromURL()
    // },1000)

    setTimeout(() => {
      removeWarehouseFromURL()
      removeExtra()
      aria_SetID()
    }, 1500)
  })

  $(document).ready(function() {
    removeWarehouseFromURL()
    locationTxtCleanUp()
    aria_SetID()
    $('.boost-pfs-filter-left-col, .boost-pfs-filter-clear-all').on('click', function() {
      displayLoader()
      filterURLChange()
      setTimeout(() => {
        document.location.reload(window.location);
      }, 500)
    })
    $('#boost-pfs-filter-tree').on('click', function() {
      displayLoader()
      filterURLChange()
      setTimeout(() => {
        document.location.reload(window.location);
      }, 500)
    })


  })


  /* Mobile Mobile Mobile */
} else if (screen.width < 767) {
  function waitMobileClick() {
    setTimeout(() => {
      $('.boost-pfs-filter-mobile-footer , .boost-pfs-filter-mobile-toolbar-right, .boost-pfs-filter-clear-all').on('click', function() {
        $('div#loading-wrapper').css({
          display: '',
          backgroundColor: '#eeeeeeee'
        })
        document.location.reload(window.location);
      })
    }, 500)
  }

  function mobileFilterURLChange() {
    let queryString = window.location.search;
    let url = window.location.href;
    let georgiaLocation = '?pf_vl_locations=Georgia+Warehouse';

    if (((url.includes('collections') || url.includes('search')) && (url.includes('?') == false))) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + georgiaLocation;
      window.history.replaceState({
        path: newurl
      }, '', newurl);

    } else if (((url.includes('collections') || url.includes('search')) && (url.includes('?')))) {
      georgiaLocation = '&pf_vl_locations=Georgia+Warehouse';
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString + georgiaLocation;
      window.history.replaceState({
        path: newurl
      }, '', newurl);

    }
  }

  function mobilefilterObserver() {
    let prodFilter_Interval = setInterval(() => {
      let prodFilter_Target = $('#boost-pfs-filter-tree')[0];
      let prodFilter_Observer = new MutationObserver(() => {
        var windowLocation = window.location.href
        if (windowLocation.includes('pf_vl_locations') == false) {
          mobileFilterURLChange()
        }
      })
      prodFilter_Observer.observe(prodFilter_Target, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: true,
      });
      clearInterval(prodFilter_Interval);
    }, 50);
  }
  window.addEventListener('DOMContentLoaded', () => {
    mobilefilterObserver()
    var windowLocation = window.location.href
    if (windowLocation.includes('pf_vl_locations') == false) {
      mobileFilterURLChange()
    }
    waitMobileClick()
    setTimeout(() => {
      $('span.refine-by-option:contains(Locations:)').closest('.refine-by-item.boost-pfs-filter-option-label').css('display', 'none');
      $('.boost-pfs-filter-option-locations').css('display', 'none');
    }, 500)
  })

  $(document).ready(function() {
    setTimeout(function() {
      var normalURL = window.location.href
      if (normalURL.includes('?pf_vl_locations')) {
        var locString = "?pf_vl_locations=Georgia+Warehouse"
      } else if (normalURL.includes('&pf_vl_locations')) {
        var locString = "&pf_vl_locations=Georgia+Warehouse"
      }
      var newString = normalURL.replace(locString, '')
      history.pushState(window.location.href, '', newString)
    }, 500)
  })
}